function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBelfastTaxiTourStartEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EBF0"
    },
    d: "M512,495.304c0,9.223-7.479,16.696-16.696,16.696H83.478C37.446,512,0,474.554,0,428.522 s37.446-83.478,83.478-83.478c18.771,0,36.131,6.234,50.087,16.733V150.261c0-9.223,7.479-16.696,16.696-16.696h134.12 c5.978,0,11.5,3.196,14.478,8.375l23.903,41.571l23.815-41.554c2.978-5.19,8.51-8.391,14.49-8.391h134.239 c9.217,0,16.696,7.473,16.696,16.696V495.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DAE4"
    },
    d: "M495.304,133.565H361.066c-5.978,0-11.511,3.201-14.49,8.391l-23.815,41.554l-23.903-41.571 c-2.979-5.179-8.5-8.375-14.478-8.375H256V512h239.304c9.217,0,16.696-7.473,16.696-16.696V150.261 C512,141.038,504.521,133.565,495.304,133.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DCA40"
    },
    d: "M478.609,478.609V166.957h-107.87c0,0-24.003,0-48.006,0s-48.006,0-48.006,0H83.478v211.478 c-27.619,0-50.087,22.468-50.087,50.087s22.468,50.087,50.087,50.087C175.778,478.609,442.671,478.609,478.609,478.609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#85BB04"
    },
    d: "M332.249,166.957l-9.488,16.554l-9.52-16.554c-20.449,0-38.514,0-38.514,0H256v311.652 c99.049,0,201.326,0,222.609,0V166.957h-107.87C370.739,166.957,352.688,166.957,332.249,166.957z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5023"
    },
    d: "M322.783,0c-46.032,0-83.478,37.446-83.478,83.478c0,12.452,2.717,24.484,8.065,35.761 c0.196,0.396,0.392,0.777,0.609,1.158l60.326,104.968c2.978,5.185,8.5,8.375,14.478,8.375h0.011 c5.978-0.006,11.5-3.207,14.478-8.391l61.217-106.864c0.304-0.538,0.587-1.092,0.837-1.657c4.597-10.636,6.934-21.853,6.934-33.348 C406.261,37.446,368.815,0,322.783,0z M322.783,100.174c-9.22,0-16.696-7.475-16.696-16.696s7.475-16.696,16.696-16.696 s16.696,7.475,16.696,16.696S332.003,100.174,322.783,100.174z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EBF0"
    },
    d: "M367.304,434.087h-89.043c-36.826,0-66.783-29.956-66.783-66.783s29.956-66.783,66.783-66.783 h111.304c18.413,0,33.391-14.978,33.391-33.391c0-18.413-14.978-33.391-33.391-33.391h-11.13c-9.217,0-16.696-7.473-16.696-16.696 s7.479-16.696,16.696-16.696h11.13c36.826,0,66.783,29.956,66.783,66.783s-29.956,66.783-66.783,66.783H278.261 c-18.413,0-33.391,14.978-33.391,33.391c0,18.413,14.978,33.391,33.391,33.391h89.043c9.217,0,16.696,7.473,16.696,16.696 S376.521,434.087,367.304,434.087z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E4A637"
    },
    cx: 428.522,
    cy: 417.391,
    r: 16.696
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#EEBE43"
    },
    cx: 250.435,
    cy: 217.043,
    r: 16.696
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DAE4"
    },
    d: "M367.304,434.087c9.217,0,16.696-7.473,16.696-16.696s-7.479-16.696-16.696-16.696h-89.043 c-8.583,0-16.339-3.345-22.261-8.685v38.181c6.975,2.477,14.446,3.896,22.261,3.896H367.304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DAE4"
    },
    d: "M389.565,200.348h-11.13c-9.217,0-16.696,7.473-16.696,16.696s7.479,16.696,16.696,16.696h11.13 c18.413,0,33.391,14.978,33.391,33.391c0,18.413-14.978,33.391-33.391,33.391H278.261c-7.815,0-15.285,1.419-22.261,3.896v38.18 c5.921-5.339,13.678-8.685,22.261-8.685h111.304c36.826,0,66.783-29.956,66.783-66.783S426.391,200.348,389.565,200.348z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4A637"
    },
    d: "M256,201.37v31.348c6.47-2.3,11.13-8.415,11.13-15.674C267.13,209.784,262.47,203.669,256,201.37z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6EBF0"
    },
    d: "M150.261,445.217c-9.217,0-16.696-7.473-16.696-16.696c0-27.619-22.468-50.087-50.087-50.087 s-50.087,22.468-50.087,50.087c0,9.223-7.479,16.696-16.696,16.696S0,437.744,0,428.522V150.261 c0-46.032,37.446-83.478,83.478-83.478s83.478,37.446,83.478,83.478v278.261C166.957,437.744,159.478,445.217,150.261,445.217z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D1DAE4"
    },
    d: "M133.565,428.522c0,9.223,7.479,16.696,16.696,16.696s16.696-7.473,16.696-16.696V150.261 c0-46.032-37.446-83.478-83.478-83.478v311.652C111.097,378.435,133.565,400.903,133.565,428.522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CD2A00"
    },
    d: "M322.783,0v66.783c9.22,0,16.696,7.475,16.696,16.696s-7.475,16.696-16.696,16.696v133.565h0.011 c5.978-0.006,11.5-3.207,14.478-8.391l61.217-106.864c0.304-0.538,0.587-1.092,0.837-1.657c4.597-10.636,6.934-21.853,6.934-33.348 C406.261,37.446,368.815,0,322.783,0z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelfastTaxiTourStartEnd);
export default __webpack_public_path__ + "static/media/belfast-taxi-tour-start-end.80685a6511e4d0ead752ede1e5aa88b5.svg";
export { ForwardRef as ReactComponent };